import React from 'react';
import {useFormikContext} from 'formik';

import {useMediaQuery} from 'src/hooks/useMediaQuery';
import AreYouSure from 'src/components/AreYouSure';
import Button from 'src/components/button';
import classnames from 'classnames';

interface Props {
  _id: string;
  onDelete: () => void;
  formName: string;
  hideDelete?: boolean;
}

const DeleteButton = ({_id, onDelete, formName, hideDelete}: Props) => {
  const mq = useMediaQuery();
  const formik = useFormikContext<{new?: boolean}>();

  if (!!formik.values.new || hideDelete) {
    return mq.MS_AND_DOWN ? null : <div className="prefix-flex prefix-flex-grow-2" />;
  }

  return (
    <div
      className={classnames('prefix-flex', 'prefix-flex-grow-2', {
        'portfolio-form-footer-delete-button': mq.MS_AND_DOWN,
      })}
    >
      <AreYouSure
        id={`delete-${_id}`}
        disabled={formik.isSubmitting}
        onYes={onDelete}
        buttonName={`${formName} form-footer`}
      >
        <Button
          color="negative"
          width="100%"
          outline
          margin={false}
          buttonName={`${formName} form-footer are-you-sure delete`}
        >
          Delete
        </Button>
      </AreYouSure>
    </div>
  );
};

export default DeleteButton;
